import React from "react";
import { useSearchParams } from "react-router-dom";
import CEOverview from "../components/econ/CEOverview";
import EconDashboards from "../components/econ/EconDashboards";
import WasteGraphView from "./WasteGraph";
import AppAllocation from "./AppAllocation";

const TABS = [
  { id: "dashboards", label: "Economics Dashboards" },
  { id: "overview", label: "Executive Overview" },
  { id: "allocation", label: "App Cost Allocation" },
  { id: "wastegraph", label: "WasteGraph" },
];

export default function CloudEconomics() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "dashboards";

  return (
    <div data-testid="cloud-economics-page">
      <div className="px-6 lg:px-10 pt-8">
        <div className="flex items-center gap-1.5 border-b border-border flex-wrap">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`ce-tab-${t.id}`}
              onClick={() => setParams({ tab: t.id })}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors duration-150 ${
                tab === t.id
                  ? "border-[#00579e] text-[#00579e]"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {tab === "allocation" ? (
        <AppAllocation />
      ) : (
        <div className="px-6 lg:px-10 pt-6 pb-8 space-y-6">
          {tab === "dashboards" && <EconDashboards />}
          {tab === "overview" && <CEOverview />}
          {tab === "wastegraph" && <WasteGraphView />}
        </div>
      )}
    </div>
  );
}
